import { IExportingProperties } from "@routes/private/Editor/types";

export interface IProps {
  exportingProperties: IExportingProperties;
  setOpenGalleryExport: Function;
  onExport: (newFolder?: string) => void;
}

export enum NOT_ALLOWED_COLLECTIONS {
  OEM = "OEM",
  DEALER_ON = "DealerOn",
  STOCK_PHOTOS = "Stock Photos"
}